import React from "react";
import { Card, Progress, Typography } from "antd";

const { Text } = Typography;

const defaultData = [
  { name: "Product01", value: 15428, orders: 154, color: "#ff6b6b" },
  { name: "Product05", value: 10582, orders: 105, color: "#feca57" },
  { name: "Product03", value: 8394, orders: 83, color: "#1dd1a1" },
  { name: "Product07", value: 6230, orders: 62, color: "#5f27cd" },
  { name: "Product09", value: 4432, orders: 44, color: "#54a0ff" },
  { name: "Product04", value: 3659, orders: 36, color: "#ff9ff3" },
];

const ProductChart = ({ data }) => {
  // Process the data from the backend or use default sample data
  const processedData = React.useMemo(() => {
    // If no data is provided or it's not an array, return the default data
    if (!data || !Array.isArray(data) || data.length === 0) {
      return defaultData;
    }
    
    try {
      // Map the backend data to the format expected by the component
      const processedData = data.map((item, index) => ({
        name: item.name || `Product${index + 1}`,
        value: item.value || 0,
        orders: item.orders || 0,
        color: [
          '#ff6b6b', '#feca57', '#1dd1a1', '#5f27cd', '#54a0ff', '#ff9ff3',
          '#00d2d3', '#ff9f43', '#ee5253', '#341f97'
        ][index % 10] // Cycle through colors
      }));
      return processedData;
    } catch (error) {
      console.error('Error processing product data:', error);
      return defaultData;
    }
  }, [data]);
  
  // Sort descending
  const sorted = [...processedData].sort((a, b) => b.value - a.value);
  const max = Math.max(...sorted.map(i => i.value || 0));

  return (
    <Card
      title="Top Products"
      className="dashboard-card"
      headStyle={{ padding: '8px 16px' }}
      bodyStyle={{ 
        padding: '8px 16px',
        maxHeight: '400px',
        overflow: 'auto',
        scrollbarWidth: 'thin',
      }}
    >
      <div className="scrollable-product-list">
        {sorted.map(({ name, value, orders, color }, idx) => (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: idx < sorted.length - 1 ? 8 : 0
            }}
          >
            <div style={{ width: '100%' }}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <Text style={{ flex: 1, fontSize: 12 }} ellipsis={{ tooltip: name }}>{name}</Text>
                <Text style={{ fontSize: 12, marginLeft: 8 }}>${value.toLocaleString()}</Text>
              </div>
              <div style={{display: 'flex', alignItems: 'center', marginBottom: 4}}>
                <Text style={{ fontSize: 11, color: '#888' }}>{orders} orders</Text>
              </div>
              <Progress
                percent={Math.round((value / max) * 100)}
                showInfo={false}
                strokeColor={color}
                strokeWidth={6}
              />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default ProductChart;
